import React from 'react';
import SampleDocument from './Samples/sample-document';
import SampleRegisteredClasses from './Samples/registered-classes-samples';
import PaystubSamples from './Samples/paystub-samples';
import FinancialStatementSamples from './Samples/financial-statement-samples';
import FafsaSamples from './Samples/fafsa-samples';
import GpaSamples from './Samples/gpa-samples';

export const SAMPLE_PAGE_PATH = '/award-payment/samples/';
export const SAMPLE_DOCUMENT_FILE_NAME = 'sample-document';
export const REGISTERED_CLASSES_SAMPLES_DOCUMENT_FILE_NAME = 'registered-classes-samples';
export const PAYSTUB_SAMPLES_DOCUMENT_FILE_NAME = 'paystub-samples';
export const FINANCIAL_STATEMENT_SAMPLES_DOCUMENT_FILE_NAME = 'financial-statement-samples';
export const FAFSA_SAMPLES_DOCUMENT_FILE_NAME = 'fafsa-samples';
export const GRADES_GPA_SAMPLES_DOCUMENT_FILE_NAME = 'grades-gpa-samples';

export const GRADES_WITH_GPA_SAMPLES_FILE_NAME = 'Grades With GPA Samples';
export const FAFSA_SAMPLES_FILE_NAME = 'FAFSA Samples';

const samplePageTitles: Record<string, string> = {
  [SAMPLE_DOCUMENT_FILE_NAME]: 'Sample Document',
  [REGISTERED_CLASSES_SAMPLES_DOCUMENT_FILE_NAME]: 'Registered Classes Samples',
  [PAYSTUB_SAMPLES_DOCUMENT_FILE_NAME]: 'Pay Stub Samples',
  [FINANCIAL_STATEMENT_SAMPLES_DOCUMENT_FILE_NAME]: 'Financial Statement Samples',
  [FAFSA_SAMPLES_DOCUMENT_FILE_NAME]: FAFSA_SAMPLES_FILE_NAME,
  [GRADES_GPA_SAMPLES_DOCUMENT_FILE_NAME]: GRADES_WITH_GPA_SAMPLES_FILE_NAME,
};

const samplePageRegistry: Record<string, React.ComponentType> = {
  [SAMPLE_DOCUMENT_FILE_NAME]: SampleDocument,
  [REGISTERED_CLASSES_SAMPLES_DOCUMENT_FILE_NAME]: SampleRegisteredClasses,
  [PAYSTUB_SAMPLES_DOCUMENT_FILE_NAME]: PaystubSamples,
  [FINANCIAL_STATEMENT_SAMPLES_DOCUMENT_FILE_NAME]: FinancialStatementSamples,
  [FAFSA_SAMPLES_DOCUMENT_FILE_NAME]: FafsaSamples,
  [GRADES_GPA_SAMPLES_DOCUMENT_FILE_NAME]: GpaSamples,
};

export const getSamplePageByPath = (_path: string = SAMPLE_PAGE_PATH, fileName: string): React.ComponentType => {
  return samplePageRegistry[fileName] ?? SampleDocument;
};

export const getSamplePageTitleByPath = (_path: string = SAMPLE_PAGE_PATH, fileName: string): string => {
  return samplePageTitles[fileName] ?? 'Sample Document';
};
